import React,{Component} from 'react';
import LoginUsername from '../static/image/loginUsername.png';
import LoginPassword from '../static/image/loginPassword.png';
import Logo from '../static/image/logo.png';
import {fetchPost} from "../static/util/fetch";
import {message,Input} from "antd";
import { withRouter } from 'react-router-dom';
import './styleDefault.css'
class SystemLogin extends Component{
    constructor(props) {
        super(props);
        this.handleInputTelNumber = this.handleInputTelNumber.bind(this);
        this.handleInputPassword = this.handleInputPassword.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
        this.handleRegister = this.handleRegister.bind(this);
        this.handleForgetPassword = this.handleForgetPassword.bind(this);
        this.state = {
            id:'',
            phone: '',
            password: '',
            code: "",
            inputCode:'',
            codeLength: 4,//验证码长度
            contentWidth: 86,
            contentHeight: 50,//内容高度/宽带
            count:0,
            showError: false,
            systemName:'',
            systemColor:''
        }
    }
    componentDidMount() {
        fetchPost(global.constants.getSysConfig,{})
            .then(
                res=>{
                    if(res.code === 200){
                        this.setState(()=>({
                            systemName:res.data.systemName,
                        }))
                        if(res.data.systemColor === 1){
                            require([`./style.css`], function(list){});
                        }
                        if(res.data.systemColor === 2){
                            require([`./styleOrange.css`], function(list){});
                        }
                        if(res.data.systemColor === 3){
                            require([`./styleGray.css`], function(list){});
                        }
                    }
                }
            )
        this.randomCode();
    }
    componentWillMount() {
        this.canvas = React.createRef();
    }


    //生成一个随机数
    randomNum = (min, max) => {
        return Math.floor(Math.random() * (max - min) + min);
    };
    //生成一个随机颜色
    randomColor(min, max) {
        const r = this.randomNum(min, max);
        const g = this.randomNum(min, max);
        const b = this.randomNum(min, max);
        return `rgb(${r}, ${g}, ${b})`;
    }
    // 绘制干扰线
    drawLine(ctx) {
        for (let i = 0; i < 1; i++) {
            ctx.strokeStyle = this.randomColor(40,180);
            //strokeStyle = color 设置图形轮廓的颜色
            ctx.beginPath();
            ctx.moveTo(
                this.randomNum(0, this.state.contentWidth),
                this.randomNum(0, this.state.contentHeight)
            );
            ctx.lineTo(
                this.randomNum(0, this.state.contentWidth),
                this.randomNum(0, this.state.contentHeight)
            );
            ctx.stroke();
        }
    }

    //绘制干扰点
    drawDot(ctx) {
        for (let i = 0; i < this.state.contentWidth/4; i++) {
            ctx.fillStyle = this.randomColor(0, 255);
            //fillStyle = color 设置图形的填充颜色
            ctx.beginPath();
            ctx.arc(
                this.randomNum(0, this.state.contentWidth),
                this.randomNum(0, this.state.contentHeight),
                1,
                0,
                2 * Math.PI
            );
            ctx.fill();
        }
    }
    drawText(ctx, txt, i) {
        //随机生成字体颜色 调用随机数函数
        ctx.fillStyle = this.randomColor(100, 200);
        //随机生成字体大小字号 调用随机数函数
        const fontSize = this.randomNum(20, 30);
        ctx.font = fontSize + "px SimHei"; //给字号加单位,生成字体

        //设置位置
        const padding = 5;
        //偏移量
        const offset = (this.state.contentWidth - 80)*(this.state.code.length - 1);
        let x = padding;
        if (i > 0) {
            x = padding + i * offset;
        }
        //调用随机数函数
        let y = this.randomNum(20, this.state.contentHeight - 5);
        const deg = this.randomNum(-10, 10);

        // 设置坐标原点和旋转角度
        ctx.translate(x, y);
        ctx.rotate((deg * Math.PI) / 180);
        ctx.fillText(txt, 0, 0);

        // 恢复坐标原点和旋转角度
        ctx.rotate((-deg * Math.PI) / 180);
        ctx.translate(-x, -y);
    }
    //生成字母数字数组
    randomCode() {
        let random = "";
        const str = "QWERTYUPLKJHGFIODSAZXCVBNMqwlioertyupkjhgfdsazxcvbnm1234567890";
        for (let i = 0; i < this.state.codeLength; i++) {
            const index = Math.floor(Math.random() * 57);
            //取得随机数的索引（0~57）
            random += str[index];
            //根据索引取得随机数加到code上
        }
        this.setState(
            {  code: random, },//赋值给code
                () => {
            const canvas = this.canvas.current;
            //拿到canvas组件 如果不懂请看ref讲解
            const ctx = canvas.getContext("2d");
            //getContext("2d") 对象是内建的 HTML5 对象
            //拥有多种绘制路径、矩形、圆形、字符以及添加图像的方法
            ctx.textBaseline = "bottom";
            //textBaseline = value 基线对齐选项
            //常用值：top, hanging, middle, bottom。

            // 绘制背景颜色
            ctx.fillStyle = this.randomColor(200, 255 );
            //fillStyle = color 设置图形的填充颜色
            ctx.fillRect(0, 0, this.state.contentWidth, this.state.contentHeight);
            //fillRect(x, y, width, height)：绘制一个填充的矩形。

            for (let i = 0; i < this.state.code.length; i++) {
                this.drawText(ctx, this.state.code[i], i);
                //调用生成字体颜色和大小及位置函数
            }
            this.drawLine(ctx); //调用绘制干扰线函数 如同的线条
              this.drawDot(ctx);//调用绘制干扰点函数 个人觉得不好看 但是也可以讲解一下,后文会在干扰线后面写
        }
    );
    }
    reloadPic = () => {
        this.randomCode();//调用生成字母数字组合函数
    };
    changeCode = (e) => {
        this.setState(()=>({
            inputCode:e.target.value
        }))
        //toLowerCase()的意思是把字符串所有英文字母转为小写
        //对验证码进行验证
        const inputCode=e.target.value.toLowerCase();
        //得到当前输入的值
        const v_code=this.state.code.toLowerCase();
        //当前canvas验证码的值
        //判断是否相等,不相等则更新
        if(inputCode!==''&&inputCode===v_code){
            this.setState({
                showError: true,
            });
        }else{
            this.setState({
                showError: false,
            });
        }
    }
    handleInputTelNumber(e){
        const value  = e.target.value;
        this.setState(()=>({
            phone:value
        }));
        const regPhone =/^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9])).{8,}$/
        const newResPhone = regPhone.test(value)
        if(value.length === 11 && newResPhone === false){
            message.info('请检查手机号是否真实！').then()
        }
    }
    handleInputPassword(e){
        const value  = e.target.value;   //value需要定义在外层
        this.setState(()=>({
            password:value
        }));
    }
    handleRegister = () =>{
        let history = this.props.history;
        history.push('/register')
    }
    handleLogin  = () => {
        let params = {
            phone: this.state.phone,
            password: this.state.password
        }
        const regPhone =/^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9])).{8,}$/
        const newResPhone = regPhone.test(this.state.phone)
        if(this.state.phone === ''||this.state.password === ''){
            message.info("请填写登录信息").then()
        }else{
            if( newResPhone === false){
                message.info('请检查该手机号是否真实！').then()
            }else{
                if(this.state.count >= 2 && this.state.inputCode === ''){
                    message.error("请输入验证码！").then()
                }else{
                    if(this.state.count >= 2 && this.state.showError === false){
                        message.error("验证码错误！").then()
                    }else{
                        fetchPost(global.constants.login, params)
                            .then(
                                res => {
                                    if(res.code === 201){
                                        localStorage.setItem("userId",res.data.id)
                                        localStorage.setItem("username",res.data.username)
                                        let history = this.props.history;
                                        history.push('/superMaster')
                                        message.success('登录成功！').then()
                                    }
                                    if(res.code === 202){
                                        localStorage.setItem("userId",res.data.id)
                                        localStorage.setItem("username",res.data.username)
                                        localStorage.setItem("identity",res.data.identity)
                                        let history = this.props.history;
                                        history.push('/companylistnavigation')
                                        message.success('登录成功！').then()
                                    }
                                    if(res.code === 200){
                                        localStorage.setItem("userId",res.data.id)
                                        localStorage.setItem("username",res.data.username)
                                        localStorage.setItem("identity",res.data.identity)
                                        this.setState(()=>({
                                            id:res.data.id,
                                        }))
                                        let history = this.props.history;
                                        history.push("/companylistnavigation")
                                        message.success('登录成功！').then()
                                    }
                                    if(res.code === -1){
                                        this.setState(()=>({
                                                phone:'',
                                                password:'',
                                                count:this.state.count + 1,
                                                inputCode:'',
                                            })
                                        )
                                        this.randomCode();
                                        message.error(res.msg).then()
                                    }
                                    if(res.code === -2){
                                        this.setState(()=>({
                                                password:'',
                                                count:this.state.count + 1,
                                                inputCode:'',
                                            })
                                        )
                                        this.randomCode();
                                        message.error("登录失败，请输入密码！").then()
                                    }
                                    if(res.code === -3){
                                        this.setState(()=>({
                                                phone:'',
                                                password:'',
                                                count:this.state.count + 1,
                                                inputCode:'',
                                            })
                                        )
                                        this.randomCode();
                                        message.error("登录失败，帐号不存在！").then()
                                    }
                                    if(res.code === -4){
                                        this.setState(()=>({
                                                password:'',
                                                count:this.state.count + 1,
                                                inputCode:'',
                                            })
                                        )
                                        this.randomCode();
                                        message.error("登录失败，密码错误！").then()
                                    }
                                    if(res.code === 500){
                                        this.setState(()=>({
                                                phone:'',
                                                password:''
                                            })
                                        )
                                        message.error("异常！").then()
                                    }
                                }
                            )
                    }
                }


            }
        }
    }
    handleForgetPassword = () =>{
        let history = this.props.history;
        history.push('/forgetPassword')
    }
    render(){
        return(
            <div className='login'>
                <div className="login-top">
                    <div className='login-header'>
                        <div className="login-header-img">
                            <img src={Logo} alt={'username'} style={{width: '35px'}}/>
                        </div>
                        <div className="login-header-word">
                            {this.state.systemName}
                        </div>
                    </div>
                </div>
                <div className="login-background">
                        {/*<img src={ZGN} alt={'zgn'} className='login-left'/>*/}
                        {/*<img src={Address} alt={'address'} className='login-left-address'/>*/}
                    <div className="loginBox">
                        <div>
                            <div className="title">{this.state.systemName}</div>
                            <div className="line">
                                <img className="smallImg" src={LoginUsername} alt={'username'}/>
                                <Input
                                    placeholder="请输入账号（手机号）"
                                    type="text"
                                    value={this.state.phone}
                                    onChange={this.handleInputTelNumber}/>
                            </div>
                            <div className="line">
                                <img className="smallImg" src={LoginPassword} alt={'password'}/>
                                <Input
                                    placeholder="请输入密码"
                                    type="password"
                                    value={this.state.password}
                                    onChange={this.handleInputPassword}/>
                            </div>
                            <div className="code-line" style={{display:this.state.count >= 2 ?'inline':'none'}}>
                                <Input
                                    placeholder="请输入验证码"
                                    type="text"
                                    value={this.state.inputCode}
                                    onChange={this.changeCode }/>
                                <canvas
                                    onClick={this.reloadPic}
                                    ref={this.canvas}
                                    className="smallImg"
                                    width="110"
                                    height="40" //设置高度宽度
                                />
                            </div>
                            <div>
                                {/*<button type="button" className="registerButton" onClick={this.handleRegister}>注&nbsp;&nbsp;册</button>*/}
                                <button type="button" className="logButton" onClick={this.handleLogin}>登&nbsp;&nbsp;录</button>
                            </div>
                            <div className='forgetPasswordLink' onClick={this.handleForgetPassword}>
                                忘记密码?
                            </div>
                        </div>
                    </div>
                    <div className={'login-footer'}>
                        版权所有：邦拓信息科技常州有限公司 &nbsp;&nbsp;&nbsp;
                        联系方式：400-0820-580 &nbsp;&nbsp;&nbsp;
                        电子邮箱： ocwy@brandter.com &nbsp;&nbsp;&nbsp;
                        <a name='netLink' href={'https://beian.miit.gov.cn/#/Integrated/index'}>ICP备：苏ICP备16030606号</a>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(SystemLogin);
